module.exports = __webpack_public_path__ + "img/bush-light.af219f7c.svg";